module.exports = __webpack_public_path__ + "static/media/lds-logo_pl.23a96000.svg";